"use strict";
function throwError(e) { throw e; }
exports.throwError = throwError;
//# sourceMappingURL=throwError.js.map


/*****************
 ** WEBPACK FOOTER
 ** /var/www/smartwifi/shared/~/rxjs/util/throwError.js
 ** module id = 84
 ** module chunks = 0 1 2
 **/